import { render, staticRenderFns } from "./realEstate.vue?vue&type=template&id=4cf0b54e&"
import script from "./realEstate.vue?vue&type=script&lang=js&"
export * from "./realEstate.vue?vue&type=script&lang=js&"
import style0 from "./realEstate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports